import React from "react";

import { crudAll, ResourceDescriptor } from "./common";

import PasswordGeneratorField from "../components/PasswordGeneratorField";

const managed_user: ResourceDescriptor = {
    url: "managed_user",
    orders: {
        update: ["password", "given_name", "family_name", "gender", "birthdate", "locale"],
    },
    crudActions: crudAll,
    muiRenderers: {
        update: {
            password: (props: any) => {
                return <PasswordGeneratorField value={props.value} onChange={props.onChange} />;
            },
        },
    },
};

export default managed_user;
